import { organizationSelector } from 'selectors/Organization';
import { selectors as billingSelectors } from 'reducers/billing';
import { Organization, Billing } from 'stores/organizations/models';

export function billing(state: any): Billing | undefined {
  const organization: Organization | undefined = organizationSelector(state);
  if (organization === undefined) {
    return undefined;
  }
  return billingSelectors.billingInfoByUUID(state, organization.uuid);
}

export function upgradeUrl(state: any): string | undefined {
  const billingInfo = billing(state);
  return billingInfo?.products?.code_review?.billing?.upgrade_url ?? undefined;
}

export const selectors = {
  billing,
  upgradeUrl,
};
